import { createContext } from "react";

const featuredServicesContext = createContext();

export default featuredServicesContext;